import Translate from "../../../utils/Translate";
import { Stack } from "@mui/material";
import BankIdAuthentication from "../../bankId/BankIdAuthentication";

let timeout;
export default function BankIdLoginFormEComp({ onLoginSuccess, startQrCodeOnDesktop }) {
  const onAuthenticationSuccess = (loginType, response) => {
    onLoginSuccess(response.data);
  };

  return (
    <Stack direction="column" spacing={3}>
      <Stack direction="column" spacing={0.8}>
        <img src="/static/BankID_logo.svg" style={{ width: "70px", height: "auto" }} />
        <h2 style={{ paddingLeft: "16px" }}>{Translate.get("LogInUsingBankId")}</h2>
      </Stack>
      <form className="loginForm">
        <BankIdAuthentication
          startAuthenticationUrl={`${import.meta.env.VITE_AUTH_URL}auth/bankid/login/digital-licenses`}
          onStatusInitiated={() => {}}
          onAuthenticationSuccess={onAuthenticationSuccess}
          startQrCodeOnDesktop={startQrCodeOnDesktop}
        />
      </form>
    </Stack>
  );
}
